import { NoticeTemplateSchedule } from '@rcp/types';
import { RestSlice } from 'src/redux/rest.slice';
import { localizationService, Resource } from 'src/services';

export const noticeTemplateScheduleSlice = new RestSlice<NoticeTemplateSchedule>(
	localizationService.getLocalizedString('notices.settings'),
	Resource.SettingNoticeTemplateSchedule
);
export default noticeTemplateScheduleSlice.rests.reducer;
